import { useEffect } from 'react';

/**
 * Comportamento comum de todo diálogo: Esc fecha e o fundo para de rolar.
 *
 * ⚠️ **A cortina precisa ficar acima do cabeçalho.** Em 14/08/2026 o cabeçalho
 * virou fixo com `z-index: 20` e passou a cobrir o topo dos diálogos — o
 * formulário de editar cliente abria com o título escondido atrás da barra.
 * A cortina está em 50; se mexer num, confira o outro.
 *
 * A trava de rolagem evita o efeito de o fundo deslizar enquanto se rola o
 * diálogo, que faz a pessoa perder o lugar onde estava.
 */
export function usarDialogo(aoFechar: () => void, ativo = true): void {
  useEffect(() => {
    /*
     * ⚠️ **Janela com outra POR CIMA não escuta o Esc** — 20/09/2026.
     *
     * O ouvinte é da janela do navegador, não do elemento, então duas camadas
     * abertas fechavam as duas com um toque: a gaveta do funil sumia junto com
     * o formulário que ela abriu, e o trabalho de quem ia só desistir da edição
     * voltava para a lista. Quem está por baixo passa `ativo: false` e volta a
     * escutar quando fica sozinho na tela.
     *
     * ⛔ **A trava de rolagem continua valendo para as duas**, e é de propósito:
     * o fundo não pode deslizar enquanto qualquer camada estiver aberta.
     */
    const antes = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    if (!ativo) {
      return () => {
        document.body.style.overflow = antes;
      };
    }

    const aoTeclar = (e: KeyboardEvent) => {
      if (e.key === 'Escape') aoFechar();
    };
    window.addEventListener('keydown', aoTeclar);

    return () => {
      window.removeEventListener('keydown', aoTeclar);
      document.body.style.overflow = antes;
    };
  }, [aoFechar, ativo]);
}
